export default {
    setBeneficiaries(state, payload) {
        state.beneficiaries = payload
    },
    setBeneficiaryAdvancedSearchCount(state, payload) {
        state.beneficiaryAdvancedSearchCount = payload
    },
    setAdvancedSearchResults(state, payload) {
        state.advancedSearchResults = payload
    },
    setCreatedBeneficiaries(state, payload) {
        state.createdBeneficiaries = payload
    },
    setBeneficiaryHistory(state, payload) {
        state.beneficiaryHistory = payload
    }
};